import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BpcFooter from '@shared/layouts/components/footer/footer.vue';
import BpcHeader from '@shared/layouts/components/header/header.vue';
import BpcPublicFooter from '@shared/layouts/components/public-footer/public-footer.vue';
import { Widget } from '@cms/interfaces/widget';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Observable } from 'rxjs';

library.add(faCog);

@Component({
  name: 'bpc-payment-layout',
  components: {
    BpcHeader,
    BpcFooter,
    BpcPublicFooter,
    VuePerfectScrollbar,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class PaymentLayout extends Vue {
  public headercolor = null;
  public sidebarcolor = null;

  public isConfigOpen: boolean = false;

  public showTopbar = true;
  public showSidebar = false;
  public showFooter = false;
  public embed = false;
  public noPadding = false;

  public loading: boolean = false;
  public widgetsSubscription = null;
  public widgets: Widget[] = [];

  public colors: string[] = [
    'bg-primary text-lighter',
    'bg-secondary text-lighter',
    'bg-success text-lighter',
    'bg-info text-lighter',
    'bg-warning text-darker',
    'bg-danger text-lighter',
    'bg-light text-darker',
    'bg-dark text-lighter',
    'bg-focus text-lighter',
    'bg-alternate text-lighter',

    'bg-vicious-stance text-lighter',
    'bg-midnight-bloom text-lighter',
    'bg-night-sky text-lighter',
    'bg-slick-carbon text-lighter',
    'bg-asteroid text-lighter',
    'bg-royal text-lighter',
    'bg-warm-flame text-darker',
    'bg-night-fade text-darker',
    'bg-sunny-morning text-darker',
    'bg-tempting-azure text-darker',
    'bg-amy-crisp text-darker',
    'bg-heavy-rain text-darker',
    'bg-mean-fruit text-darker',
    'bg-malibu-beach text-darker',
    'bg-deep-blue text-darker',
    'bg-ripe-malin text-lighter',
    'bg-arielle-smile text-lighter',
    'bg-plum-plate text-lighter',
    'bg-happy-fisher text-darker',
    'bg-happy-itmeo text-darker',
    'bg-mixed-hopes text-lighter',
    'bg-strong-bliss text-lighter',
    'bg-grow-early text-lighter',
    'bg-love-kiss text-lighter',
    'bg-premium-dark text-lighter',
    'bg-happy-green text-lighter',
  ];

  public loadedStyles: boolean = false;

  /* Lifecycle hooks */
  // created () { }
  mounted() {
    const query = this.$route.query;

    // if ('showTopbar' in query && query.showTopbar === 'true') {
    //   this.showTopbar = true;
    // }

    if ('showSidebar' in query && query.showSidebar === 'true') {
      this.showSidebar = true;
    }

    if ('showFooter' in query && query.showFooter === 'true') {
      this.showFooter = true;
    }

    if ('embed' in query && query.embed === 'true') {
      this.embed = true;
    }

    if ('noPadding' in query && query.noPadding === 'true') {
      this.noPadding = true;
    }
  }
  // updated () { }
  // destroyed () { }

  public toggleConfig(className) {
    const el = document.body;
    this.isConfigOpen = !this.isConfigOpen;

    if (this.isConfigOpen) {
      el.classList.add(className);
    } else {
      el.classList.remove(className);
    }
  }

  beforeMount() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      this.appendStyles();
    }
  }

  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  get logo() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].logo_url
    ) {
      let logo = this.$store.getters['centerSettings/centerSettings'].logo_url;
      if (typeof logo === 'string') {
        logo = JSON.parse(logo);
      }
      return logo.url;
    }
    return null;
  }

  get name() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].name;
    }
    return null;
  }
  get header_image_url() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].header_image_url
    ) {
      let headerImageUrl = this.$store.getters['centerSettings/centerSettings'].header_image_url;
      if (typeof headerImageUrl === 'string') {
        headerImageUrl = JSON.parse(headerImageUrl);
      }
      return headerImageUrl.url;
    }
    return null;
  }
  get publicFooter() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].public_footer;
    }
    return null;
  }
  get publicCss() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].public_css;
    }
    return null;
  }
  get centerSettings() {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  @Watch('centerSettings')
  onCenterSettings() {
    this.appendStyles();
  }

  appendStyles() {
    const css = this.publicCss;
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    head.appendChild(style);
    /* if (style.styleSheet){
        // This is required for IE8 and below.
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      } */
    style.appendChild(document.createTextNode(css));

    this.loadedStyles = true;
  }

  public getWidgets(): void {
    this.loading = true;

    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('widgets', 'raw')}`;

    const queryConfig = {
      params: {
        published: 1,
        orderBy: 'ordering',
        orderDirection: 'asc',
      },
    };

    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(
      fetchEntityPath,
      queryConfig,
    );

    if (this.widgetsSubscription) {
      this.widgetsSubscription.unsubscribe();
    }

    this.widgetsSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.widgets = res.data;
        this.loading = false;
      },
      error => {
        console.log(error);
        this.loading = false;
      },
    );
  }

  public getWidgetsByArea(area: string): Widget[] {
    return this.widgets.filter(widget => widget.area === area);
  }

  public hasWidgetInArea(area: string): boolean {
    return !!this.getWidgetsByArea(area).length;
  }
}
